import Stack from '@mui/material/Stack';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection.tsx';
import { useTranslation } from 'react-i18next';
import { AllowedOrganizationItem } from './AllowedOrganizationItem.tsx';
import type { AudienceShare } from './types.ts';
import { groupAudienceSharesByFee } from './utils.ts';

export function AllowedOrganizations({ audienceShares }: { audienceShares: AudienceShare[] }) {
  const { t } = useTranslation();

  const allowedOrganizationsList = groupAudienceSharesByFee(audienceShares);

  if (allowedOrganizationsList.length === 0) {
    return null;
  }

  return (
    <FormSection title={t('Allowed Partners')} description={t('The audience is shared with the following partner(s)')}>
      <Stack spacing={2}>
        {allowedOrganizationsList.map(({ shareId, fee, recipients, revenueMethod }) => (
          <AllowedOrganizationItem
            key={shareId}
            name={recipients.map(({ name }) => name).join(', ')}
            fee={fee}
            method={revenueMethod}
          />
        ))}
      </Stack>
    </FormSection>
  );
}
